<template>
  <div class="add-container-modal">
    <v-dialog v-model="dialog" :max-width="maxWidth" persistent>
      <v-card :class="{ 'pa-7': !breakpointXs, 'pa-2': breakpointXs }">
        <v-card-title class="justify-space-between">
          <div class="add-container-modal--title fw-600" :class="{ 'fs-25': !breakpointXs, 'fs-20': breakpointXs }">
            Add New Container
          </div>
          <v-btn icon @click="$emit('close-container-modal')">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text :class="{ 'pt-5': !breakpointXs, 'pt-0': breakpointXs }">
          <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="containerNo"
                  rules="required|max:15"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAddContainerFormLoading || savingExportJob"
                  label="Container No"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <AutoComplete
                  v-model="containerSizeDropdownValue"
                  :return-object="true"
                  item-text="text"
                  :items="containerSizes"
                  rules="required"
                  required
                  aria-required
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAddContainerFormLoading || savingExportJob"
                  label="Container Size"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="sealNumber"
                  showIcons
                  rules="required|max:35"
                  :showOnlyErrorIcons="true"
                  :loading="isAddContainerFormLoading || savingExportJob"
                  label="Seal Number"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <DateField
                  v-model="sealDate"
                  rules="required"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAddContainerFormLoading || savingExportJob"
                  :inputLabel="'Seal Date'"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <AutoComplete
                  v-model="sealTypeDropdownValue"
                  :items="containerSealTypes"
                  rules="required"
                  :return-object="true"
                  item-text="text"
                  required
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAddContainerFormLoading || savingExportJob"
                  label="Seal Type"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <AutoComplete
                  v-model="containerTypeDropdownValue"
                  :items="containerTypes"
                  :return-object="true"
                  item-text="text"
                  rules="required"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAddContainerFormLoading || savingExportJob"
                  label="Container Type"
                />
              </v-col>
            </v-row>
            <v-card-actions class="d-block d-sm-flex justify-end">
              <v-btn
                color="button-primary"
                outlined
                large
                :block="breakpointXs"
                width="140"
                @click="$emit('close-container-modal')"
              >
                <span class="font-weight-bold fs-15">Cancel</span>
              </v-btn>
              <v-btn
                width="140"
                color="button-primary"
                large
                :block="breakpointXs"
                :class="{ 'white--text': true, 'my-3': !breakpointXs, 'ml-0 mt-3': breakpointXs }"
                :loading="isAddContainerFormLoading || savingExportJob"
                @click="passes(saveContainer)"
              >
                <span class="font-weight-bold fs-15">Save</span>
              </v-btn>
            </v-card-actions>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import AutoComplete from "@/components/AutoComplete";
import DateField from "@/components/DateField";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import handleExportJobMixin from "@/modules/DashboardModule/modules/ImportExportModule/mixins/handleExportJobMixin";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "AppContainerModal",
  components: {
    ValidationObserver,
    TextField,
    AutoComplete,
    DateField
  },
  data() {
    return {
      dialog: true,
      isAddContainerFormLoading: false
    };
  },
  props: {
    maxWidth: {
      type: String,
      default: "350"
    },
    srNo: {
      type: Number,
      default: 1
    },
    newContainer: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.newContainer) {
      //this.makeFieldsNull();
    }
  },
  beforeDestroy() {
    this.makeFieldsNull();
  },
  mixins: [commonMethodsMixin, handleExportJobMixin],
  methods: {
    saveContainer() {
      const container = { ...this.$store.getters.container };
      container.srNo = this.srNo;
      this.$store.commit(MT.SET_CONTAINER_IN_EXPORT_JOB, { container: container, srNo: container.srNo });
      this.$emit("close-container-modal");
    },
    makeFieldsNull() {
      this.sealNumber = null;
      this.size = null;
      this.sealDate = "";
      this.sealType = null;
      this.containerNo = null;
      this.containerType = null;
      this.containerSizeDropdownValue = "";
      this.sealTypeDropdownValue = "";
      this.containerTypeDropdownValue = "";
    }
  },
  computed: {
    containerSealTypes() {
      return this.$store.getters.containerSealTypes;
    },
    containerSizes() {
      return this.$store.getters.containerSizes;
    },
    containerTypes() {
      return this.$store.getters.containerTypes;
    },
    containerNo: {
      get() {
        return this.$store.state.ExportModuleStore.container.containerNo;
      },
      set(value) {
        this.$store.commit(MT.SET_CONTAINER_CONTAINER_NO, { value });
      }
    },
    containerSizeDropdownValue: {
      get() {
        const selectedcontainerSize = this.size;
        if (selectedcontainerSize !== "" && !!selectedcontainerSize) {
          return this.containerSizes.find(type => type.textIdentifier.includes(selectedcontainerSize));
        } else {
          return this.containerSizes;
        }
      },
      set(containerSizeObject) {
        this.$store.commit(MT.SET_CONTAINER_CONTAINER_SIZE, {
          value: containerSizeObject.textIdentifier
        });
      }
    },

    size: {
      get() {
        return this.$store.state.ExportModuleStore.container.containerSize;
      },
      set(value) {
        this.$store.commit(MT.SET_CONTAINER_CONTAINER_SIZE, { value });
      }
    },
    sealNumber: {
      get() {
        return this.$store.state.ExportModuleStore.container.exciseSealNo;
      },
      set(value) {
        this.$store.commit(MT.SET_CONTAINER_EXCISE_SEAL_NO, { value });
      }
    },
    sealDate: {
      get() {
        return this.$store.state.ExportModuleStore.container.sealDate;
      },
      set(value) {
        this.$store.commit(MT.SET_CONTAINER_SEAL_DATE, { value });
      }
    },
    sealTypeDropdownValue: {
      get() {
        const selectedsealType = this.sealType;
        if (selectedsealType !== "" && !!selectedsealType) {
          return this.containerSealTypes.find(type => type.textIdentifier.includes(selectedsealType));
        } else {
          return this.containerSealTypes;
        }
      },
      set(sealTypeObject) {
        this.$store.commit(MT.SET_CONTAINER_SEAL_TYPE_INDICATOR, {
          value: sealTypeObject.textIdentifier
        });
        this.sealType = sealTypeObject.textIdentifier;
      }
    },

    sealType: {
      get() {
        return this.$store.state.ExportModuleStore.container.sealTypeIndicator;
      },
      set(value) {
        this.$store.commit(MT.SET_CONTAINER_SEAL_TYPE_INDICATOR, { value });
      }
    },
    containerTypeDropdownValue: {
      get() {
        const selectedcontainerType = this.containerType;
        if (selectedcontainerType !== "" && !!selectedcontainerType) {
          return this.containerTypes.find(type => type.textIdentifier.includes(selectedcontainerType));
        } else {
          return this.containerTypes;
        }
      },
      set(containerTypeObject) {
        this.$store.commit(MT.SET_CONTAINER_MOVEMENT_DOCUMENT_TYPE, {
          value: containerTypeObject.textIdentifier
        });
      }
    },

    containerType: {
      get() {
        return this.$store.state.ExportModuleStore.container.movementDocumentType;
      },
      set(value) {
        this.$store.commit(MT.SET_CONTAINER_MOVEMENT_DOCUMENT_TYPE, { value });
      }
    }
  }
};
</script>
